export const EmailPattern = /\S+@\S+\.\S+/
export const UpperCasePattern = /.*[A-Z].*/
export const LowerCasePattern = /[a-z]/
export const NumberPattern = /\d/
export const SymbolPattern = /[*@!#%&()^~{}+%$_-]+/
export const SpecialCharacterSlug = /[^a-zA-Z0-9.]/g
export const UrlPattern = /^https?:\/\/[-a-zA-Z0-9@:._+~]{1,256}\./
export const IntegerFrom1To8Pattern = /^0*(?:[1-8]?|8)$/
export const TwoDecimalPlacesPattern = /^\d*(\.\d{0,2})?$/
export const ImageTypePattern = /.(?:jpg|jpeg|gif|png)/
export const JiraTicketPattern = /^[A-Za-z0-9]{2,10}-[0-9]{1,5}$/
export const NonNegativeIntegerPattern = /^[0-9]\d*$/
export const InvalidCharsPattern = /[;&%]/
export const NumbersAndDotOnlyPattern = /[^0-9.]/g

export type FormSubmitValues<T> = {
  [K in keyof T]: T[K] | null
}
